import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface PendingPurchase {
  item: string;
  item_id: string;
  price: number;
  currency: string;
  extras?: Record<string, unknown>;
}

interface PaymentInitialState {
  status: 'success' | 'pending' | undefined;
  pendingPurchase: PendingPurchase | null;
}

const initialState: PaymentInitialState = {
  status: undefined,
  pendingPurchase: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    changePaymentStatus: (
      state,
      { payload }: PayloadAction<'success' | 'pending' | undefined>,
    ) => {
      state.status = payload;
    },
    setPendingPurchase: (
      state,
      { payload }: PayloadAction<PendingPurchase>,
    ) => {
      state.pendingPurchase = payload;
    },
    clearPendingPurchase: (state) => {
      state.pendingPurchase = null;
    },
  },
});

export const { changePaymentStatus, setPendingPurchase, clearPendingPurchase } =
  paymentSlice.actions;
export default paymentSlice.reducer;
export type { PendingPurchase };
